import React, {useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import './slab.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../modal";

const IncentiveSlab = ({createIncentiveSlab, incentiveSlabRes = null}) => {

    const [count, setCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{project_id: ''}]);
    const [projectIdValidation, setProjectIdValidation] = useState("")

    const [gmcList, setGmcList] = useState([{start: 0, end: 0, price: 0}])
    const handleGmcInputValue = (val, key, index) => {
        const list = [...gmcList];
        list[index][key] = val;
        setGmcList([...list]);
    };

    const handleGmcRemoveClick = index => {
        const list = [...gmcList];
        list.splice(index, 1);
        setGmcList(list);
    };

    const [ratingList, setRatingList] = useState([{start: 0, end: 0, price: 0}])
    const handleRatingInputValue = (val, key, index) => {
        const list = [...ratingList];
        list[index][key] = val;
        setRatingList([...list]);
    };

    const handleRatingRemoveClick = index => {
        const list = [...ratingList];
        list.splice(index, 1);
        setRatingList(list);
    };

    const [onlineTaxList, setOnlineTaxList] = useState([{start: 0, end: 0, price: 0}])
    const handleOnlineTaxInputValue = (val, key, index) => {
        const list = [...onlineTaxList];
        list[index][key] = val;
        setOnlineTaxList([...list]);
    };

    const handleOnlineTaxRemoveClick = index => {
        const list = [...onlineTaxList];
        list.splice(index, 1);
        setOnlineTaxList(list);
    };

    const [dropTatList, setDropTatList] = useState([{start: 0, end: 0, price: 0}])
    const handleDropTatInputValue = (val, key, index) => {
        const list = [...dropTatList];
        list[index][key] = val;
        setDropTatList([...list]);
    };

    const handleDropTatRemoveClick = index => {
        const list = [...dropTatList];
        list.splice(index, 1);
        setDropTatList(list);
    };

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    // handle click event of the Add button
    const handleAddGmcClick = () => {
        setGmcList(
            [
                ...gmcList, {
                start: 0, end: 0, price: 0
            }
            ]
        );
    };

    const handleAddRatingClick = () => {
        setRatingList(
            [
                ...ratingList,
                {
                    start: 0, end: 0, price: 0
                }
            ]
        );
    };

    const handleAddOnlineTnxClick = () => {
        setOnlineTaxList(
            [
                ...onlineTaxList,
                {
                    start: 0, end: 0, price: 0
                }
            ]
        );
    };

    const handleAddDropTatClick = () => {
        setDropTatList(
            [
                ...dropTatList,
                {
                    start: 0, end: 0, price: 0
                }
            ]
        );
    };

    const handleOnSubmitForm = async () => {
        setProjectIdValidation("")
        if(inputList[0]['project_id'] === ""){
            setProjectIdValidation("Project id is required")
        }

        let incentiveSlabDetails = {gmc: '', rating: '', drop_tat: '', online_tax: ''}
        incentiveSlabDetails['gmc'] = gmcList
        incentiveSlabDetails['rating'] = ratingList
        incentiveSlabDetails['drop_tat'] = dropTatList
        incentiveSlabDetails['online_txn'] = onlineTaxList
        incentiveSlabDetails['project_id'] = inputList[0]['project_id']

        if (incentiveSlabDetails['project_id'] !== "") {
            setIsLoading(true)
            await createIncentiveSlab(incentiveSlabDetails)
            setIsLoading(false)
            setCount(count+1)
        }
    }

    return (
        <>
            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        {incentiveSlabRes !== null && incentiveSlabRes.response.status !== 200 &&
                            <CustomModal msg={incentiveSlabRes.response.message} click={count}/>}
                        {incentiveSlabRes !== null && incentiveSlabRes.response.status === 200 &&
                            <CustomModal msg={incentiveSlabRes.response.message} isPageLoad={true} click={count} />}
                        <div className="card-header">
                            {localization.incentivelab}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="validation">{projectIdValidation}</div>
                                    <ConstantInput
                                        label={localization.projectId}
                                        type="number"
                                        value={inputList.project_id}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'project_id', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="gmc-value">
                                    <p className="heading">Add Gmc</p>
                                    {gmcList.map((value, index) => {
                                        return (
                                            <>
                                                <div className="container col-lg-12 ">
                                                    <div className="col-md-4" key={index + 1}>
                                                        <ConstantInput
                                                            label={localization.start}
                                                            type="number"
                                                            value={value.start}
                                                            handleChange={(val) => {
                                                                handleGmcInputValue(val, 'start', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 2}>
                                                        <ConstantInput
                                                            label={localization.end}
                                                            type="number"
                                                            value={value.end}
                                                            handleChange={(val) => {
                                                                handleGmcInputValue(val, 'end', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 3}>
                                                        <ConstantInput
                                                            label={localization.price}
                                                            type="number"
                                                            value={value.price}
                                                            handleChange={(val) => {
                                                                handleGmcInputValue(val, 'price', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="btn-box mb-4">
                                                    {gmcList.length !== 1 && <button
                                                        onClick={() => handleGmcRemoveClick(index)}
                                                        className="btn btn-sm btn-danger mr10">Remove</button>}
                                                    {gmcList.length - 1 === index &&
                                                        <button className="btn btn-sm btn-primary"
                                                                onClick={handleAddGmcClick}>Add</button>}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>

                                <div className="rating-value">
                                    <p className="heading">Add Rating</p>
                                    {ratingList.map((value, index) => {
                                        return (
                                            <>
                                                <div className="container col-lg-12 ">
                                                    <div className="col-md-4" key={index + 1}>
                                                        <ConstantInput
                                                            label={localization.start}
                                                            type="number"
                                                            value={value.start}
                                                            handleChange={(val) => {
                                                                handleRatingInputValue(val, 'start', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 2}>
                                                        <ConstantInput
                                                            label={localization.end}
                                                            type="number"
                                                            value={value.end}
                                                            handleChange={(val) => {
                                                                handleRatingInputValue(val, 'end', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 3}>
                                                        <ConstantInput
                                                            label={localization.price}
                                                            type="number"
                                                            value={value.price}
                                                            handleChange={(val) => {
                                                                handleRatingInputValue(val, 'price', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="btn-box mb-4">
                                                    {ratingList.length !== 1 && <button
                                                        onClick={() => handleRatingRemoveClick(index)}
                                                        className="btn btn-sm btn-danger mr-10">Remove</button>}
                                                    {ratingList.length - 1 === index &&
                                                        <button className="btn btn-sm btn-primary"
                                                                onClick={handleAddRatingClick}>Add</button>}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>

                                <div className="online-tnx-value">
                                    <p className="heading">Add Online Tnx</p>
                                    {onlineTaxList.map((value, index) => {
                                        return (
                                            <>
                                                <div className="container col-lg-12 ">
                                                    <div className="col-md-4" key={index + 1}>
                                                        <ConstantInput
                                                            label={localization.start}
                                                            type="number"
                                                            value={value.start}
                                                            handleChange={(val) => {
                                                                handleOnlineTaxInputValue(val, 'start', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 2}>
                                                        <ConstantInput
                                                            label={localization.end}
                                                            type="number"
                                                            value={value.end}
                                                            handleChange={(val) => {
                                                                handleOnlineTaxInputValue(val, 'end', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 3}>
                                                        <ConstantInput
                                                            label={localization.price}
                                                            type="number"
                                                            value={value.price}
                                                            handleChange={(val) => {
                                                                handleOnlineTaxInputValue(val, 'price', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="btn-box mb-4">
                                                    {onlineTaxList.length !== 1 && <button
                                                        onClick={() => handleOnlineTaxRemoveClick(index)}
                                                        className="btn btn-sm btn-danger mr-10">Remove</button>}
                                                    {onlineTaxList.length - 1 === index &&
                                                        <button className="btn btn-sm btn-primary"
                                                                onClick={handleAddOnlineTnxClick}>Add</button>}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>

                                <div className="drop-value">
                                    <p className="heading">Add Drop Tat</p>
                                    {dropTatList.map((value, index) => {
                                        return (
                                            <>
                                                <div className="container col-lg-12 ">
                                                    <div className="col-md-4" key={index + 1}>
                                                        <ConstantInput
                                                            label={localization.start}
                                                            type="number"
                                                            value={value.start}
                                                            handleChange={(val) => {
                                                                handleDropTatInputValue(val, 'start', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 2}>
                                                        <ConstantInput
                                                            label={localization.end}
                                                            type="number"
                                                            value={value.end}
                                                            handleChange={(val) => {
                                                                handleDropTatInputValue(val, 'end', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4" key={index + 3}>
                                                        <ConstantInput
                                                            label={localization.price}
                                                            type="number"
                                                            value={value.price}
                                                            handleChange={(val) => {
                                                                handleDropTatInputValue(val, 'price', index);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="btn-box mb-4">
                                                    {dropTatList.length !== 1 && <button
                                                        onClick={() => handleDropTatRemoveClick(index)}
                                                        className="btn btn-sm btn-danger mr-10">Remove</button>}
                                                    {dropTatList.length - 1 === index &&
                                                        <button className="btn btn-sm btn-primary"
                                                                onClick={handleAddDropTatClick}>Add</button>}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};
export default IncentiveSlab
